/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DataWarehouseProductDTO
 */
export interface DataWarehouseProductDTO {
  /**
   *
   * @type {number}
   * @memberof DataWarehouseProductDTO
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof DataWarehouseProductDTO
   */
  ean?: string;
  /**
   *
   * @type {string}
   * @memberof DataWarehouseProductDTO
   */
  merchant?: string;
  /**
   *
   * @type {string}
   * @memberof DataWarehouseProductDTO
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof DataWarehouseProductDTO
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof DataWarehouseProductDTO
   */
  category?: string;
  /**
   *
   * @type {string}
   * @memberof DataWarehouseProductDTO
   */
  price: string;
  /**
   *
   * @type {string}
   * @memberof DataWarehouseProductDTO
   */
  currency?: string;
  /**
   *
   * @type {string}
   * @memberof DataWarehouseProductDTO
   */
  image_url?: string;
  /**
   *
   * @type {string}
   * @memberof DataWarehouseProductDTO
   */
  product_url?: string;
}

/**
 * Check if a given object implements the DataWarehouseProductDTO interface.
 */
export function instanceOfDataWarehouseProductDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "price" in value;

  return isInstance;
}

export function DataWarehouseProductDTOFromJSON(json: any): DataWarehouseProductDTO {
  return DataWarehouseProductDTOFromJSONTyped(json, false);
}

export function DataWarehouseProductDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataWarehouseProductDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    ean: !exists(json, "ean") ? undefined : json["ean"],
    merchant: !exists(json, "merchant") ? undefined : json["merchant"],
    name: !exists(json, "name") ? undefined : json["name"],
    description: !exists(json, "description") ? undefined : json["description"],
    category: !exists(json, "category") ? undefined : json["category"],
    price: json["price"],
    currency: !exists(json, "currency") ? undefined : json["currency"],
    image_url: !exists(json, "image_url") ? undefined : json["image_url"],
    product_url: !exists(json, "product_url") ? undefined : json["product_url"]
  };
}

export function DataWarehouseProductDTOToJSON(value?: DataWarehouseProductDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    ean: value.ean,
    merchant: value.merchant,
    name: value.name,
    description: value.description,
    category: value.category,
    price: value.price,
    currency: value.currency,
    image_url: value.image_url,
    product_url: value.product_url
  };
}
